import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder,FormGroup, ValidationErrors, FormArray, FormControl } from '@angular/forms';
import { DialogService, UtilitaryService,AdresseService,ParameterService } from '../../../../services';
import { AtylService } from '../../../service/atyl.service';
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse';
import { BaseDialogComponent } from '../../../../base/dialog-base/dialog-base.component';
@Component({
    selector: 'form-dialog-secteur',
    styleUrls: ['./form-dialog-secteur.component.css'],
    templateUrl: 'form-dialog-secteur.component.html',
})
export class FormDialogSecteurComponent extends BaseDialogComponent implements OnInit {
     myGeoControl:FormControl = new FormControl();
    myGroupGeo:FormGroup;
    adresseValues: any = {};
    secteurs: any = [];
    all_secteur:any= [];
    checked:any = 'row unverified';
    zones:any={
		
	}
	
	default:any={
	}
    constructor(
        public dialogRef: MatDialogRef<FormDialogSecteurComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private atylService: AtylService,
        private utilities: UtilitaryService,
        changeDetector: ChangeDetectorRef,
        dialogService: DialogService,
         private adresseService: AdresseService,
         private parameterService: ParameterService,        
         private formBuilder: FormBuilder,
    ) {
        super(dialogRef, dialogService, changeDetector);

    }

    ngOnInit(){
        this.utilities.log(this.data);
       
        //this.myGroupGeo=this.data.group;
        this.myGroupGeo=this.formBuilder.group({});
       console.log("FormDialogSecteurComponent ngOnInit",this.data)
        if (this.data.controls["zones"]!=undefined &&  this.data.controls["zones"].value!=undefined)   
        	this.default = this.data.controls["zones"].value;
        this.adresseValues.villeid = this.data.controls["ville"].value;
        this.adresseValues.cp = this.data.controls["code"].value;
        this.adresseValues.numrue = this.data.controls["num"].value;
        this.adresseValues.comp = this.data.controls["comp"].value;
        this.adresseValues.rue = this.data.controls["rue"].value;
       
        
        this.parameterService.getAllZones().subscribe((r)=> {
           // console.log("FormDialogSecteurComponent getAllZones",r.result,this.default)
            Object.keys(r.result).forEach(elt => {
				 this.all_secteur.push(r.result[elt]);
				 let formState:string='';
					 
				 
				 if (this.default[elt]!=undefined && this.default[elt] )
				 	formState=this.default[elt]+'';
				 console.log("FormDialogSecteurComponent getAllZones",formState)	
				this.myGroupGeo.addControl(elt, new FormControl(formState));
				this.zones[elt]=parseInt(formState);
				 
			});	
            //this.all_secteur=r.result;
            console.log("FormDialogSecteurComponent ALL",this.zones)	
				
         //   this.changeDetectorRef.detectChanges();
            
            this.getZoneAddress();
        });
        
      
        
        
    }
    
    ngOnDestroy() {
		this.zones={};
		this.default={};
	}
	
    getZoneAddress() {
		 let _opts={
			
            "numero" : this.adresseValues.numrue,
            "rueid": this.adresseValues.rue
          
		 }
		
		 this.adresseService.zones(this.adresseValues.villeid,_opts  ).subscribe((result:JSONRpcResponse)=> {
            //if (result.result.length>0) {
	            Object.keys(result.result).forEach(element => {
	                if(result.result[element][0])
	                    this.secteurs.push({"type":result.result[element][0].zone.zoneType.libelle, "libelle":result.result[element][0].zone.libelle});
	                this.checked = "row confirm";
	                console.log("FormDialogSecteurComponent element",element,this.myGroupGeo.get(element),result.result[element][0]);
	               if (result.result[element][0] &&
	                this.myGroupGeo.get(element)!=undefined 
	                && this.myGroupGeo.get(element)) {
						//if (this.myGroupGeo.get(element).value!=result.result[element][0].zone.id+'') {
							console.log("FormDialogSecteurComponent value",this.myGroupGeo.get(element).value,result.result[element][0].zone.id+'');
						//	this.myGroupGeo.get(element).setValue(result.result[element][0].zone.id+'');
							this.myGroupGeo.get(element).reset(result.result[element][0].zone.id+'')
	                	//}
	                	//console.log("FormDialogSecteurComponent value",result.result[element][0].zone.id+'');
	                	
	                	this.zones[element]=result.result[element][0].zone.id;
	                 }
	                
	            });
         	//}
            console.log("FormDialogSecteurComponent ZALL",this.zones)	
			
           this.changeDetectorRef.detectChanges();
        });
        
        this.utilities.log(this.adresseValues);
	}
    
    onGeoChanged(evnt:any,tzone:string) {
		console.log("onGeoChanged",evnt,tzone);
		this.zones[tzone]=parseInt(evnt.value);
	}
}